export function decimalToBoolean(value?: string) {
    return Boolean(value && parseFloat(value));
}
